// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { InterceptionTargetSchema } from '../inputTypeSchemas/InterceptionTargetSchema'
import { InterceptionActionSchema } from '../inputTypeSchemas/InterceptionActionSchema'

/////////////////////////////////////////
// INTERCEPTION OVERRIDE SCHEMA
/////////////////////////////////////////

export const InterceptionOverrideSchema = z.object({
  target: InterceptionTargetSchema,
  action: InterceptionActionSchema,
  key: z.string(),
  value: z.string(),
})

export type InterceptionOverride = z.infer<typeof InterceptionOverrideSchema>

export default InterceptionOverrideSchema;
